import { useCallback } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

export type Locale = 'el' | 'en';

export function getLanguageFromPath(path: string): Locale {
  return path === '/en' || path.startsWith('/en/') ? 'en' : 'el';
}

export function stripLanguagePrefix(path: string): string {
  if (path === '/en') {
    return '/';
  }
  if (path.startsWith('/en/')) {
    return path.slice(3);
  }
  return path;
}

export function withLanguagePrefix(path: string, language: Locale): string {
  if (language === 'en') {
    if (path === '/') {
      return '/en';
    }
    return path.startsWith('/en/') ? path : `/en${path}`;
  }

  if (path === '/en') {
    return '/';
  }
  if (path.startsWith('/en/')) {
    return path.slice(3);
  }
  return path;
}

export function useLocalizedPath() {
  const { language } = useLanguage();

  return useCallback(
    (path: string) => withLanguagePrefix(path, language),
    [language],
  );
}
